const hmNotValid = entity => (`Hmm, that’s not a valid ${entity}.`)

const nameNotValid = entity => (`${entity} names may contain only letters, periods, dashes, spaces, and apostrophes.`)

const nameWithNumberNotValid = entity => (`${entity} names may contain only letters, numbers, periods, dashes, spaces, and apostrophes.`)

const notMatch = entity => `${entity} doesn’t match. Please try again.`

const notFutureDate = entity => `${entity} can not be a set in the future.`

const bannedWord = entity => `You cannot use the word "${entity}". Please try again.`

export const firstNameValidation = {
  messages: {
    isValidPersonName: nameNotValid('First')
  },
  rules: {
    isValidPersonName: true
  }
}

export const employerPlanNameValidation = {
  messages: {
    isValidNameWithNumber: nameWithNumberNotValid('Employer plan')
  },
  rules: {
    isValidNameWithNumber: true
  }
}

export const middleNameValidation = {
  messages: {
    isValidPersonName: nameNotValid('Middle')
  },
  rules: {
    isValidPersonName: true
  }
}

export const lastNameValidation = {
  messages: {
    isValidPersonName: nameNotValid('Last')
  },
  rules: {
    isValidPersonName: true
  }
}

export const birthdateValidation = {
  rules: {
    isValidStartingDate: true,
    isNotFutureDate: true,
  },
  messages: {
    isValidStartingDate: hmNotValid('date'),
    isNotFutureDate: notFutureDate('Birth date'),
  }
}


export const dateOfDeathValidation = {
  rules: {
    isValidStartingDate: true,
    isNotFutureDate: true,
  },
  messages: {
    isValidStartingDate: hmNotValid('date'),
    isNotFutureDate: notFutureDate('Date of death'),
  }
}

export const fundNameValidation = {
  rules: {
    isValidFundName: true,
  },
  messages: {
    isValidFundName: bannedWord('Trust'),
  }
}

export const birthdateConfirmationValidation = {
  rules: {
    isBirthdateMatch: true
  },
  messages: {
    isBirthdateMatch: notMatch('Date of Birth'),
  }
}

export const donorDobConfirmationValidation = {
  rules: {
    isDonorDobMatch: true
  },
  messages: {
    isDonorDobMatch: notMatch('Date of Birth'),
  }
}

export const deceasedDobConfirmationValidation = {
  rules: {
    isDeceasedDobMatch: true
  },
  messages: {
    isDeceasedDobMatch: notMatch('Date of Birth'),
  }
}

export const minorDobConfirmationValidation = {
  rules: {
    isMinorDobMatch: true
  },
  messages: {
    isMinorDobMatch: notMatch('Date of Birth'),
  }
}

export const minorSsnConfirmationValidation = {
  rules: {
    isValidMinorSsnMatch: true
  },
  messages: {
    isValidMinorSsnMatch: notMatch('Social Security Number'),
  }
}

export const contactBirthdateValidation = {
  rules: {
    isValidStartingDate: true,
    isValidAge: true
  },
  messages: {
    isValidStartingDate: hmNotValid('date'),
    isValidAge: hmNotValid('date')
  }
}

export const postalCodeValidation = {
  rules: {
    isValidPostalCode: true
  },
  messages: {
    isValidPostalCode: 'Zipcodes may contain only numbers, letters and dashes.'
  }
}

export const cityValidation = {
  messages: {
    isValidEntityName: hmNotValid('city')
  },
  rules: {
    isValidEntityName: true
  }
}

export const stateValidation = {
  messages: {
    isValidEntityName: hmNotValid('state')
  },
  rules: {
    isValidEntityName: true
  }
}

export const employerIdNumberValidation = {
  rules: {
    isValidEmployerIdNumber: true
  },
  messages: {
    isValidEmployerIdNumber: hmNotValid('identification number')
  }
}

export const employerIncomeTaxDate = {
  rules: {
    isValidIncomeTaxDate: true
  },
  messages: {
    isValidIncomeTaxDate: hmNotValid('income tax date')
  }
}

export const phoneNumberValidation = {
  rules: {
    isValidPhoneNumber: true
  },
  messages: {
    isValidPhoneNumber: hmNotValid('phone number')
  }
}

export const ssnValidation = {
  rules: {
    isValidSocialSecurityNumber: true
  },
  messages: {
    isValidSocialSecurityNumber: hmNotValid('Social Security Number')
  }
}

export const ssnConfirmationValidation = {
  rules: {
    isValidSsnMatch: true
  },
  messages: {
    isValidSsnMatch: notMatch('Social Security Number'),
  }
}

export const deceasedSsnConfirmationValidation = {
  rules: {
    isValidDeceasedSsnMatch: true
  },
  messages: {
    isValidDeceasedSsnMatch: notMatch('Social Security Number'),
  }
}

export const donorSsnConfirmationValidation = {
  rules: {
    isValidDonorSsnMatch: true
  },
  messages: {
    isValidDonorSsnMatch: notMatch('Social Security Number'),
  }
}

export const percentageValidation = {
  rules: {
    isValidPercentage: true,
  },
  messsages: {
    isValidPercentage: hmNotValid('percentage')
  }
}

export const currencyValidation = {
  rules: {
    isValidCurrencyNumber: true,
  },
  messsages: {
    isValidCurrencyNumber: hmNotValid('currency')
  }
}

export const dateValidation = {
  rules: {
    isValidDate: true
  },
  messages: {
    isValidDate: hmNotValid('date')
  }
}

export const trustDateValidation = {
  rules: {
    isValidTrustDate: true
  },
  messages: {
    isValidTrustDate: hmNotValid('date')
  }
}

export const yearValidation = {
  rules: {
    isValidYear: true
  },
  messages: {
    isValidYear: hmNotValid('year')
  }
}

export const countryValidation = {
  messages: {
    isValidEntityName: hmNotValid('country')
  },
  rules: {
    isValidEntityName: true
  }
}

export const identificationNumberValidation = {
  rules: {
    isValidIdentificationNumber: true
  },
  messages: {
    isValidIdentificationNumber: 'This field may contain only letters, numbers, and spaces.'
  }
}

export const taxIdentificationNumberValidation = {
  rules: {
    isValidTaxIdNumber: true
  },
  messages: {
    isValidTaxIdNumber: 'The Tax ID Number may only contain numbers and dashes.'
  }
}

export const trustNameValidation = {
  messages: {
    isValidNameWithNumber: nameWithNumberNotValid('Trust')
  },
  rules: {
    isValidNameWithNumber: true
  }
}

export const organizationNameValidation = {
  messages: {
    isValidPersonName: nameNotValid('Organization')
  },
  rules: {
    isValidPersonName: true
  }
}



// WEBPACK FOOTER //
// ./src/utils/fieldValidations.js